import { __ } from '@wordpress/i18n';

export const TEMPLATE_CATEGORIES = {
	patterns: [
		'Hero',
		'CTA',
		'Testimonial',
		'Team',
		'FAQ',
	],
	pages: [
		'Homepage',
		'About',
		'Services',
	],
	kits: [] // Kits may not have categories, or we’ll define if needed
};

export const getTabs = () => ([
	{ key: 'patterns', label: __('Patterns', 'vayu-blocks') },
	{ key: 'pages', label: __('Templates', 'vayu-blocks') },
//{ key: 'kits', label: __('Templates', 'vayu-blocks') },
	{ key: 'favorites', label: __('Favorites', 'vayu-blocks') },
]);

export const SORT_OPTIONS = [
	{ label: 'Default', value: 'default' },
	{ label: 'Newest First', value: 'newest' },
	{ label: 'Most Popular', value: 'popular' },
	{ label: 'Title (A–Z)', value: 'title' },
];